import { parse, stringify } from './urlHelpers';

/** Query params que solo abren/cerran capas UI en la misma vista. */
export const OVERLAY_ONLY_SEARCH_KEYS = [
  'access',
  'accessContext',
  'mobilemenu',
  'mobilesearch',
  'orderOpen',
];

export const searchWithoutOverlayOnlyKeys = search => {
  const params = parse(search || '');
  const rest = Object.keys(params).reduce((acc, key) => {
    if (!OVERLAY_ONLY_SEARCH_KEYS.includes(key)) {
      acc[key] = params[key];
    }
    return acc;
  }, {});
  return stringify(rest);
};

/**
 * Misma ruta y hash; la query solo difiere en params de overlay (modal login, menú, panel reserva…).
 */
export const isOnlyOverlaySearchChange = (prevLocation, nextLocation) => {
  if (!prevLocation || !nextLocation) {
    return false;
  }
  if (prevLocation.pathname !== nextLocation.pathname || prevLocation.hash !== nextLocation.hash) {
    return false;
  }
  return (
    searchWithoutOverlayOnlyKeys(prevLocation.search) ===
    searchWithoutOverlayOnlyKeys(nextLocation.search)
  );
};
